import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarStatusDropdownContentWireframe from './VeltCommentsSidebarStatusDropdownContentWireframe/VeltCommentsSidebarStatusDropdownContentWireframe';
import VeltCommentsSidebarStatusDropdownTriggerWireframe from './VeltCommentsSidebarStatusDropdownTriggerWireframe/VeltCommentsSidebarStatusDropdownTriggerWireframe';
;
var VeltCommentsSidebarStatusDropdownWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarStatusDropdownWireframe.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatusDropdownWireframe.Content = VeltCommentsSidebarStatusDropdownContentWireframe;
export default VeltCommentsSidebarStatusDropdownWireframe;
